import { render, staticRenderFns } from "./Jumper.vue?vue&type=template&id=b95d544c&scoped=true&"
import script from "./Jumper.vue?vue&type=script&lang=js&"
export * from "./Jumper.vue?vue&type=script&lang=js&"
import style0 from "./Jumper.vue?vue&type=style&index=0&id=b95d544c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95d544c",
  null
  
)

export default component.exports